import { FC, ReactNode } from "react";
import styles from "./ManagementPointCard.module.scss";
import { P15, P3 } from "../../Typography";
import { SvgFeather } from "@/lib/ui/icons";

interface IManagementPointCard {
  icon: ReactNode;
  text: string;
  onClick?: () => void;
}
export const ManagementPointCard: FC<IManagementPointCard> = ({ text, onClick, icon }) => {

  return (
    <div className={styles.card} onClick={onClick}>
      <SvgFeather className={styles.card__featherImage} />
      <div className={styles.card__wrapper}>
        {icon}
        <P15 className={styles.card__mainText}>{text}</P15>
      </div>
    </div>
  );
};
